import React, {Fragment} from "react";
import PropTypes from "prop-types";
import AddDowntimeForm from "../../Forms/AddDowntime";
import AddMetricForm from "../../Forms/AddMetricForm";
import AddSensorDowntime from "../../Forms/AddSensorDowntime";
import "./styles.scss";

const AlertForm = (props) => {
  const {closeAlertForm, data, metricType, showAlertForm} = props;

  return (
    <Fragment>
      {metricType === "metric" ? (
        <AddMetricForm
          closeAlertForm={closeAlertForm}
          data={data}
          showAlertForm={showAlertForm}
        />
      ) : metricType === "downtime" ? (
        <AddDowntimeForm
          closeAlertForm={closeAlertForm}
          data={data}
          showAlertForm={showAlertForm}
        />
      ) : (
        <AddSensorDowntime
          closeAlertForm={closeAlertForm}
          data={data}
          showAlertForm={showAlertForm}
        />
      )}
    </Fragment>
  );
};

AlertForm.propTypes = {
  closeAlertForm: PropTypes.func.isRequired,
  data: PropTypes.object,
  metricType: PropTypes.string.isRequired,
  showAlertForm: PropTypes.bool.isRequired,
};

export default AlertForm;
